import ENVIRONMENTS, {
  getKeycloakLoginUrl,
  getKeycloakRedirectUri,
  isConfiguredKeycloakUrl,
} from '../../environments';

const POST_AUTH_RETURN_KEY = 'qc_post_auth_return';

export function isPurchaseDeepLink(pathname: string, search: string): boolean {
  return (
    pathname.replace(/\/+$/, '') === '/u/quickcam-credits' &&
    new URLSearchParams(search).get('purchase') === '1'
  );
}

export function signInForPurchase(pathname: string, search: string): boolean {
  if (!isConfiguredKeycloakUrl(ENVIRONMENTS.KEYCLOAK_ACCOUNT)) return false;
  try {
    sessionStorage.setItem(POST_AUTH_RETURN_KEY, `${pathname}${search}`);
    localStorage.setItem('redirect_uri', getKeycloakRedirectUri());
  } catch (error) {
    console.warn('Could not keep the purchase for after sign-in:', error);
  }
  window.location.replace(getKeycloakLoginUrl());
  return true;
}
